import { Upload, ClipboardList, Sparkles } from "lucide-react";

const TOOLS = [
  {
    href: "/admin/upload",
    icon: Upload,
    title: "Upload Portal",
    desc: "Parse PDFs, generate questions, and manage the question bank.",
  },
  {
    href: "/admin/review-questions",
    icon: ClipboardList,
    title: "Review Questions",
    desc: "Browse, edit, and manage all saved questions.",
  },
  {
    href: "/admin/refine-explanations",
    icon: Sparkles,
    title: "Refine Explanations",
    desc: "Clean up garbled AI explanations using Claude.",
  },
];

export function AdminLandingPage() {
  return (
    <div className="min-h-screen bg-[#f8f9fc] flex flex-col items-center justify-center p-8">
      <h1 className="text-2xl font-bold text-[#1a2435] mb-2">Admin Tools</h1>
      <p className="text-sm text-[#5a6a7e] mb-10">Select a tool to continue</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-xl">
        {TOOLS.map(({ href, icon: Icon, title, desc }) => (
          <a
            key={href}
            href={href}
            className="group bg-white border border-[#dde3ed] hover:border-[#1a3a6b] rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-200 flex flex-col gap-3"
          >
            <div className="w-10 h-10 rounded-xl bg-[#1a3a6b]/8 flex items-center justify-center group-hover:bg-[#1a3a6b]/15 transition-colors">
              <Icon className="w-5 h-5 text-[#1a3a6b]" />
            </div>
            <div>
              <p className="font-semibold text-[#1a2435] text-sm group-hover:text-[#1a3a6b] transition-colors">{title}</p>
              <p className="text-xs text-[#5a6a7e] mt-0.5 leading-relaxed">{desc}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
